import { apiSlice } from '@/features/api/apiSlice';

export type TenantTokens = {
  colors?: Record<string, string>;
  fonts?: Record<string, string>;
  spacing?: Record<string, string>;
};

export const tokensApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    getTokens: b.query<TenantTokens, void>({
      query: () => '/design-tokens',
      providesTags: ['Tokens'],
    }),
    updateTokens: b.mutation<unknown, TenantTokens>({
      query: (body) => ({ url: '/design-tokens', method: 'PUT', body }),
      invalidatesTags: ['Tokens'],
    }),
  }),
});

export const { useGetTokensQuery, useUpdateTokensMutation } = tokensApi;
